import { render, staticRenderFns } from "./UcCompanyGeneral.yaml?vue&type=template&id=e7b7e224&component"
import script from "./UcCompanyGeneral.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompanyGeneral.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports